<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Dedication</p>
<p class="txt">To Matthew.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?54d5a7a5